import React, { Fragment } from "react";
import * as ReactDOM from "react-dom";
import styled from "styled-components";
import { IUserMessage, UserMessageType } from "../models/user-message.model";
import { Collapsible } from "./Collapsible";
import { StyledDialog } from "./Dialog.styled";
import { Button } from "@magnetic/react-components";
import { ThemeProvider, getTheme } from "@magnetic/react-components"; 

const Footer = (props: IMessageBoxProps) => {
  if (props.hideClose && !props.onCancel && !props.onRetry) {
    return null;
  } 
  
  return (
    <>
      {!props.hideClose && (<Button type="button" onClick={props.onClose}>Close</Button>)}
      {props.onCancel && (<Button type="button" onClick={props.onCancel}>Cancel</Button>)}
      {props.onRetry && (<Button type="button" onClick={props.onRetry} disabled={props.retrying}>Retry</Button>)}
    </>
  );  
};

const Body = (props: IMessageBoxProps) => (  
  <ThemeProvider theme={getTheme("Enlyte")}>
    <StyledDialog 
      title={UserMessageType[props.type] === UserMessageType[UserMessageType.Error]
              ? "Error"
              : UserMessageType[props.type] === UserMessageType[UserMessageType.Warning]
              ? "Warning"
              : UserMessageType[props.type] === UserMessageType[UserMessageType.Custom]
              ? props.title
              : "Info"}
      isModal={true} isOpen={true} onCancel={props.onCancel} style={{}} className="relogin" footer={Footer(props)}>
      <div style={{ padding: "2rem" }}>
        <div className="msgbox-container">
          {UserMessageType[props.type] !== UserMessageType[UserMessageType.Custom] && (
            <div className="msgbox-icon">
              <span className="mi-icon-alert-filled-triangle"></span>
            </div>)
          }
          <div className="msgbox-msg">{props.message}</div>
        </div>
        {props.detail && <Collapsible title="More Details" text={props.detail} />}                           
      </div>       
    </StyledDialog>    
  </ThemeProvider>
);

interface IMessageBoxProps {
  type: UserMessageType;
  title: string;
  message: string;
  detail: any;  
  retrying: boolean;
  hideClose,
  onClose(): any;
  onCancel(): any;
  onRetry(): any;
}

export class MessageBox extends React.Component<IMessageBoxProps> {
  constructor(props: IMessageBoxProps) {
    super(props);
  }

  onClose = () => {
    this.props.onClose();
  };

  render() {
    let body;
    body = (
      <Body
        type={this.props.type}
        title={this.props.title}
        message={this.props.message}
        detail={this.props.detail}        
        retrying={this.props.retrying}
        hideClose={this.props.hideClose}
        onClose={this.props.onClose}
        onCancel={this.props.onCancel}
        onRetry={this.props.onRetry}
      />
    );
    return (
      <Fragment>
        {body}                        
      </Fragment>
    );
  }

  static show(userMessage: IUserMessage) {
    const divElem = document.createElement("div");
    divElem.setAttribute("id", "JitUx-MessageBox");
    document.body.appendChild(divElem);
    let dom = document.getElementById("JitUx-MessageBox");

    const destroy = () => {
      if (dom) {
        ReactDOM.unmountComponentAtNode(dom);
        document.body.removeChild(dom);
        dom = null;
      }
    };

    const onClose = () => {
      destroy();
    };

    const onCancel = () => {
      userMessage.handleCancel();
      destroy();
    };

    const onRetry = () => {
      input.retrying = true;

      //Re-render the component with new input value
      component(input);

      userMessage.handleRetry().then(
        result => {
          input.retrying = false;
          destroy();
        },
        error => {
          input.retrying = false;
          destroy();
        }
      );
    };

    const input: IMessageBoxProps = {
      type: userMessage.type,
      title: userMessage.title,
      message: userMessage.message,
      detail: userMessage.detail,      
      retrying: false,
      hideClose: userMessage.hideClose,
      onClose: onClose,
      onCancel: userMessage.handleCancel ? onCancel : null,
      onRetry: userMessage.handleRetry ? onRetry : null
    };

    const component = input => ReactDOM.render(<MessageBox {...input} />, dom);
    component(input);
  }
}
